import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';

/* stylelint-disable value-no-vendor-prefix, property-no-vendor-prefix */
export const StyledMemberExclusiveBanner = styled.div`
  ${rtl`
    @media only ${theme.mediaQuery.allMobiles} {
      .member-exclusive-banner {
        margin : 0 ${toRem(16)} !important;
      }
    }
    @media only ${theme.mediaQuery.largerMobile} {
      .member-exclusive-banner {
        margin-left : ${toRem(70)} !important;
        margin-right : ${toRem(84)} !important;
      }
    }
    @media only ${theme.mediaQuery.largerMobile} {
        margin-right : ${toRem(74)} !important;
    }
    .list-banner {
      border-bottom: ${toRem(1)} dashed ${theme.color['dark-gray-6']};
      margin-bottom: ${toRem(16)} !important;
    }
    .member-exclusive-banner {
      &.map-view {
        .banner-container {
          padding: 0;
          padding-top: ${toRem(16)};
          @media only ${theme.mediaQuery.minDesktop} {
            margin: 0;
            border-bottom: ${toRem(1)} dashed ${theme.color['dark-gray-6']};
            padding-bottom: ${toRem(10)};
          }

          @media only ${theme.mediaQuery.smallerTablet} {
            border-bottom: none;
            margin: 0;
          }

          @media only ${theme.mediaQuery.allMobiles} {
            border-bottom: none;
            margin: 0 ${toRem(2)};
          }
          @media only ${theme.mediaQuery.largerMobile} {
            margin: 0 ${toRem(50)};
          }
        }
      }
      .banner-container {
        padding: ${toRem(20)} 0;
        @media only ${theme.mediaQuery.largerMobile} {
          margin: 0 ${toRem(44)};
        }
        margin-bottom: ${toRem(12)};
        .banner-section {
          align-items: flex-start !important;
          padding: 0;
          width: fit-content;
          .icon-holder {
            border-radius: 50%;
            background: ${theme.color['orange-roughy']};
            margin-right: ${toRem(8)};
            padding: ${toRem(11)} ${toRem(12)} ${toRem(13)};
          }
          .banner-label-container {
            display: flex;
            flex-direction: column;
            .banner-text {
              font-weight: ${theme.fonts['fontWeightRegular']};
            }
          }
        }
      }
      @media only ${theme.mediaQuery.allTablets} {
        .map-banner{
          margin-left: ${toRem(24)} !important;
        }
        .banner-container {
          width: 100% ;
          .banner-section {
            .icon-holder {
              margin-right: ${toRem(8)};
            }
          }
        }
      }
      @media only ${theme.mediaQuery.allMobiles} {
        .banner-container {
          padding: ${toRem(14)} 0;
          width: 100%;
          .banner-section {
            .icon-holder {
              padding: ${toRem(8)} ${toRem(9)} ${toRem(10)};
            }
          }
        }
      }
    }
  `}
`;
